// 📁 src/components/WelcomeMenuBubble.jsx
import React from 'react';
import * as LucideIcons from 'lucide-react';

const WelcomeMenuBubble = ({ message, onOptionClick, isProcessing }) => {
    // Log para depuración
    console.log(`[WelcomeMenuBubble Render] Recibió message:`, message);

    if (!message) return null;

    // 🔥 Extraemos campos priorizando mensaje_coach
    const titulo = message.mensaje_coach?.titulo || message.titulo || "Sin título";
    const texto = message.mensaje_coach?.texto || message.content || "Sin contenido";
    const iconoCoach = message.mensaje_coach?.icono || "Home";
    const IconCoach = LucideIcons[iconoCoach] || LucideIcons.Home;

    console.log("[🧠 WelcomeMenuBubble] TÍTULO:", titulo);
    console.log("[🧠 WelcomeMenuBubble] TEXTO:", texto);

    return (
        <div className="p-4 bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-lg border border-blue-100 mb-3">
            {titulo && (
                <div className="flex items-center mb-4">
                    <IconCoach className="w-16 h-16 md:w-6 md:h-6 text-indigo-600 mr-3" />
                    <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
            )}
            {texto && (
                <p className="text-base text-gray-700 mb-5 whitespace-pre-line leading-relaxed"
                   dangerouslySetInnerHTML={{ __html: texto }} />
            )}
            <div className="flex flex-col gap-2">
                {message.opciones?.map((opcion, index) => {
                    const Icon = LucideIcons[opcion.icono] || LucideIcons.HelpCircle;
                    return (
                        <button
                            key={index}
                            onClick={() => onOptionClick(opcion)}
                            disabled={isProcessing}
                        	className="flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-[#3B0E6D] to-[#6B21A8] text-white text-base font-bold shadow-lg hover:from-[#4C1D95] hover:to-[#7C3AED] hover:shadow-indigo-500/40 transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed"

                        >
                            <Icon className="w-4 h-4 mr-2" />
                            {opcion.etiqueta}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default WelcomeMenuBubble;
